<template>
  <report
    :title="$t('language.monthlypresentabsent')"
    :filter="filter"
    :url="url"
    :landscape="true"
  >
    <template v-slot:filter>
      <v-flex xs12 sm12 md3>
        <ValidationProvider
          :name="$t('language.year')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.year"
            :items="YearList"
            item-text="name"
            item-value="id"
            :label="$t('language.year')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm12 md3>
        <ValidationProvider
          :name="$t('language.month')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.month"
            :items="MonthList"
            item-text="name"
            item-value="id"
            :label="$t('language.month')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.personid"
          :items="PersonList"
          item-text="name"
          item-value="id"
          :label="$t('language.person')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.branchid"
          :items="BranchList"
          item-text="name"
          item-value="id"
          :label="$t('language.branch')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.departmentid"
          :items="DepartmentList"
          item-text="name"
          item-value="id"
          :label="$t('language.department')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.designationid"
          :items="DesignationList"
          item-text="name"
          item-value="id"
          :label="$t('language.designation')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.modeid"
          :items="ModeList"
          item-text="name"
          item-value="id"
          :label="$t('language.mode')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
    </template>
    <template v-slot:printheader>
      <table class="printheader">
        <tbody>
          <tr>
            <td>{{ $t("language.year") }}:{{ selectedyear }}</td>
            <td></td>
            <td>{{ $t("language.month") }}:{{ selectedmonth }}</td>
            <td></td>
            <td>{{ $t("language.person") }}:{{ selectedperson }}</td>
            <td></td>
            <td>{{ $t("language.branch") }}:{{ selectedbranch }}</td>
            <td></td>
            <td>{{ $t("language.department") }}:{{ selecteddepartment }}</td>
            <td></td>
            <td>{{ $t("language.designation") }}:{{ selecteddesignation }}</td>
            <td></td>
            <td>{{ $t("language.mode") }}:{{ selectedmode }}</td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-slot:table="{ data }">
      <table class="table table-bordered w-100 print-align-center align-center">
        <thead>
          <tr>
            <th width="150" rowspan="2">{{ $t("language.name") }}</th>
            <th rowspan="2">{{ $t("language.designationshort") }}</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
            <th>8</th>
            <th>9</th>
            <th>10</th>
            <th>11</th>
            <th>12</th>
            <th>13</th>
            <th>14</th>
            <th>15</th>
            <th>16</th>
            <th>17</th>
            <th>18</th>
            <th>19</th>
            <th>20</th>
            <th>21</th>
            <th>22</th>
            <th>23</th>
            <th>24</th>
            <th>25</th>
            <th>26</th>
            <th>27</th>
            <th>28</th>
            <th v-if="data.totaldays > 28">29</th>
            <th v-if="data.totaldays > 29">30</th>
            <th v-if="data.totaldays > 30">31</th>
            <th v-if="data.totaldays > 31">32</th>
          </tr>
          <tr>
            <th>{{ $t("language." + data.dayOfWeek[0]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[1]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[2]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[3]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[4]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[5]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[6]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[7]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[8]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[9]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[10]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[11]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[12]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[13]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[14]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[15]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[16]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[17]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[18]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[19]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[20]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[21]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[22]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[23]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[24]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[25]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[26]) }}</th>
            <th>{{ $t("language." + data.dayOfWeek[27]) }}</th>
            <th v-if="data.totaldays > 28">
              {{ $t("language." + data.dayOfWeek[28]) }}
            </th>
            <th v-if="data.totaldays > 29">
              {{ $t("language." + data.dayOfWeek[29]) }}
            </th>
            <th v-if="data.totaldays > 30">
              {{ $t("language." + data.dayOfWeek[30]) }}
            </th>
            <th v-if="data.totaldays > 31">
              {{ $t("language." + data.dayOfWeek[31]) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data.detail" :key="index">
            <td>{{ item.person }}</td>
            <td>{{ item.designation }}</td>
            <td>{{ item.day1 }}</td>
            <td>{{ item.day2 }}</td>
            <td>{{ item.day3 }}</td>
            <td>{{ item.day4 }}</td>
            <td>{{ item.day5 }}</td>
            <td>{{ item.day6 }}</td>
            <td>{{ item.day7 }}</td>
            <td>{{ item.day8 }}</td>
            <td>{{ item.day9 }}</td>
            <td>{{ item.day10 }}</td>
            <td>{{ item.day11 }}</td>
            <td>{{ item.day12 }}</td>
            <td>{{ item.day13 }}</td>
            <td>{{ item.day14 }}</td>
            <td>{{ item.day15 }}</td>
            <td>{{ item.day16 }}</td>
            <td>{{ item.day17 }}</td>
            <td>{{ item.day18 }}</td>
            <td>{{ item.day19 }}</td>
            <td>{{ item.day20 }}</td>
            <td>{{ item.day21 }}</td>
            <td>{{ item.day22 }}</td>
            <td>{{ item.day23 }}</td>
            <td>{{ item.day24 }}</td>
            <td>{{ item.day25 }}</td>
            <td>{{ item.day26 }}</td>
            <td>{{ item.day27 }}</td>
            <td>{{ item.day28 }}</td>
            <td v-if="data.totaldays > 28">{{ item.day29 }}</td>
            <td v-if="data.totaldays > 29">{{ item.day30 }}</td>
            <td v-if="data.totaldays > 30">{{ item.day31 }}</td>
            <td v-if="data.totaldays > 31">{{ item.day32 }}</td>
          </tr>
        </tbody>
        <tfoot v-if="data.detail.length == 0">
          <tr>
            <th :colspan="data.totaldays + 2">
              {{ $t("language.nodatafound") }}
            </th>
          </tr>
        </tfoot>
        <tfoot v-if="data.detail.length > 0">
          <tr>
            <th align="left" :colspan="data.totaldays + 2">
              {{ data.abbrText }}
            </th>
          </tr>
        </tfoot>
      </table>
    </template>
  </report>
</template>

<script>
import axios from "axios";
import Report from "../Report";
import commonservice from "../../../../shared/common.service";
export default {
  components: {
    Report,
  },
  data() {
    return {
      filter: {
        year: commonservice.getCurrentYear(),
        month: commonservice.getCurrentMonth(),
        personid: null,
        branchid: null,
        departmentid: null,
        designationid: null,
        modeid: null,
      },
      YearList: [],
      MonthList: commonservice.getMonthList(),
      PersonList: [],
      BranchList: [],
      DepartmentList: [],
      DesignationList: [],
      ModeList: [],
      url: "client/report/monthly/presentabsents",
    };
  },
  computed: {
    selectedyear() {
      if (this.filter.year == null) return this.$t("language.all");
      return this.YearList.filter((c) => {
        return c.id == this.filter.year;
      })[0].name;
    },
    selectedmonth() {
      if (this.filter.month == null) return this.$t("language.all");
      return this.MonthList.filter((c) => {
        return c.id == this.filter.month;
      })[0].name;
    },
    selectedperson() {
      if (this.filter.personid == null) return this.$t("language.all");
      return this.PersonList.filter((c) => {
        return c.id == this.filter.personid;
      })[0].name;
    },
    selectedbranch() {
      if (this.filter.branchid == null) return this.$t("language.all");
      return this.BranchList.filter((c) => {
        return c.id == this.filter.branchid;
      })[0].name;
    },
    selecteddepartment() {
      if (this.filter.departmentid == null) return this.$t("language.all");
      return this.DepartmentList.filter((c) => {
        return c.id == this.filter.departmentid;
      })[0].name;
    },
    selecteddesignation() {
      if (this.filter.designationid == null) return this.$t("language.all");
      return this.DesignationList.filter((c) => {
        return c.id == this.filter.designationid;
      })[0].name;
    },
    selectedmode() {
      if (this.filter.modeid == null) return this.$t("language.all");
      return this.ModeList.filter((c) => {
        return c.id == this.filter.modeid;
      })[0].name;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/report/monthly/init/list").then((response) => {
      next((p) => {
        p.DepartmentList = response.data.departments;
        p.BranchList = response.data.branches;
        p.DesignationList = response.data.designations;
        p.ModeList = response.data.modes;
        p.YearList = response.data.years;
        p.PersonList = response.data.persons;
      });
    });
  },
};
</script>
